module.exports = __webpack_public_path__ + "img/flecha-cima-circulada.014c0ea5.svg";